import { UseToastOptions } from "@chakra-ui/react";
import { errorToastOptions } from "../../components/molecules/errorToastOptions";
import { parseErrorToUserMessage } from "./parsers/parseErrorToUserMessage";

/**
 * Parse any Error into toast options, including the display message.
 *
 * A SylaApiError will generally result in a meaningful toast message, but any
 * error will still result in some message, by providing a default fallback.
 */
export function errorToToastOptions(error: unknown): UseToastOptions {
  return {
    ...errorToastOptions,
    ...parseErrorToUserMessage(error),
  };
}
